// import React from 'react';
// import './learn.css';
// import { Post } from '../../@/components';
// import { useParams, useNavigate } from 'react-router-dom';

// const Learn = ({ articles }) => {
//   const { articleSlug } = useParams();
//   const navigate = useNavigate();

//   const handleReadMore = (article) => {
//     navigate(`/ideas/${article.slug}`);
//   };

//   const handleCloseModal = () => {
//     navigate('/ideas');
//   };

//   return (
//     <div className="learn" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//       <Post 
//         articles={articles} 
//         onReadMore={handleReadMore} 
//         selectedArticle={articles.find(a => a.slug === articleSlug)}
//         onCloseModal={handleCloseModal}
//       />
//       <div className="ulev__learn section__padding" id=""></div>
//     </div>
//   );
// };

// export default Learn;







import React, { useState, useRef } from 'react';
import './learn.css';
import { Post } from '../../@/components';
import link from '../../main_assets/link.PNG';
import emailjs from '@emailjs/browser';

const Learn = ({ articles = [] }) => {
  // Contact form state
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailStatus, setEmailStatus] = useState('');
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    time: new Date().toLocaleString() 
  });

  // Initialize EmailJS
  React.useEffect(() => {
    emailjs.init("ISG04P_c0uObH1Og8");
  }, []);

  const toggleEmailForm = () => {
    setShowEmailForm(prev => !prev);
    if (!showEmailForm) {
      document.body.classList.add('popup-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('popup-open');
      document.body.style.overflow = 'auto';
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      time: new Date().toLocaleString() 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailStatus('sending');
    
    const templateParams = {
      from_name: formData.name,
      email: formData.email,
      to_email: "marcel.ulevus@gmail.com",
      reply_to: formData.email,
      company: formData.company,
      message: formData.message,
      time: formData.time,
      to_name: "Ulevus Team",
      subject: `New contact from ${formData.name}${formData.company ? ` at ${formData.company}` : ''}`
    };
    
    const serviceId = 'service_yf0fnk1';
    const templateId = 'template_azclhrj';
    
    emailjs.send(serviceId, templateId, templateParams)
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setEmailStatus('success');
        setFormData({
          name: '',
          email: '',
          company: '',
          message: '',
          time: new Date().toLocaleString()
        });
        setTimeout(() => {
          setEmailStatus('');
        }, 3000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        setEmailStatus('error');
      });
  };

  return (
    <div className="learn">
      <Post articles={articles} />
      <div className="ulevlearn sectionpadding"></div>
      
      <div className="ulev__footer-icotext section__padding">
        <button 
          onClick={toggleEmailForm}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginRight: 'auto', 
            background: 'none', 
            border: 'none',
            cursor: 'pointer'
          }}
        >
          <p className='reach' style={{ marginRight: '10px', color: "#888" }}>Connect with us</p>
        </button>

        <button 
          className='cont' 
          onClick={toggleEmailForm}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginLeft: 'auto', 
            marginTop: '25px', 
            cursor: 'pointer', 
            background: 'none', 
            border: 'none' 
          }}
        >
          <span style={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
            <img src={link} alt="linked" />
          </span>
        </button>
      </div>

      {/* Contact Form Modal */}
      {showEmailForm && (
        <div className="email-modal-overlay" onClick={toggleEmailForm}>
          <div className="email-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send us a message</h3>
              <button 
                className="close-button"
                onClick={toggleEmailForm}
                type="button"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            
            {emailStatus === 'success' ? (
              <div className="email-success">
                <p>Your message has been sent successfully!</p>
                <button 
                  className="close-button-success" 
                  onClick={toggleEmailForm}
                  type="button"
                >
                  Close
                </button>
              </div>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} className="dark-form">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your email address"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="styled-input"
                    placeholder="Your company"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Tell us about your project</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    className="styled-textarea"
                    placeholder="Describe your project or inquiry"
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="submit-button minimal-submit"
                  disabled={emailStatus === 'sending'}
                >
                  {emailStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>
                
                {emailStatus === 'error' && (
                  <p className="error-message">
                    Failed to send message. Please try again or contact us directly at info@ulevus.com
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Learn;